import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {UserService} from '../service/user.service';
import {Keys, StorageService} from '../service/storage.service';
import {UserUtil} from '../utils/UserUtil';

@Injectable()
export class OnlyUsersWithoutLoanGuard implements CanActivate {
    constructor(private userService: UserService, private storageService: StorageService,
                private userUtil: UserUtil, private router: Router) {
    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
        if (!this.userUtil.isUserLoggedIn()) {
            return true;
        }

        const userId = this.storageService.getItem(Keys.PROFILE_ID);
        const token = this.storageService.getItem(Keys.TOKEN);
        const response = await this.userService.getUserLenderApplicationStatus(userId, token);
        return await this.userUtil.hasAssociatedLoan(response.user) ?
            this.router.createUrlTree(['/borrow']) : true;
    }
}
